const NAVIGATING_CLASS = 'dickson-page-is-navigating';
const NAV_DONE_CLASS = 'dickson-page-nav-done';

/**
 * @param {MouseEvent} event
 * @returns {boolean}
 */
function isModifiedClick(event) {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
}

/**
 * @param {HTMLAnchorElement} anchor
 * @returns {boolean}
 */
function isEligibleAnchor(anchor) {
  if (!anchor.href) return false;
  if (anchor.hasAttribute('download')) return false;

  const target = anchor.getAttribute('target');
  if (target && target !== '_self') return false;

  const rel = (anchor.getAttribute('rel') || '').toLowerCase();
  if (rel.includes('external')) return false;

  // Ignore pure hash links (same-page anchors).
  const rawHref = anchor.getAttribute('href') || '';
  if (rawHref.startsWith('#')) return false;

  try {
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    return true;
  } catch {
    return false;
  }
}

function startNavigationBar() {
  document.body.classList.add(NAVIGATING_CLASS);
  document.body.classList.remove(NAV_DONE_CLASS);
}

function finishNavigationBar() {
  if (!document.body.classList.contains(NAVIGATING_CLASS)) return;
  document.body.classList.add(NAV_DONE_CLASS);

  window.setTimeout(() => {
    document.body.classList.remove(NAVIGATING_CLASS);
    document.body.classList.remove(NAV_DONE_CLASS);
  }, 350);
}

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;
    if (!(event instanceof MouseEvent)) return;
    if (isModifiedClick(event)) return;

    const anchor = event.target.closest('a[href]');
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (!isEligibleAnchor(anchor)) return;

    startNavigationBar();
  },
  { capture: true }
);

// Hook into View Transitions navigation events when supported.
window.addEventListener('pageswap', () => startNavigationBar());
window.addEventListener('pagereveal', () => finishNavigationBar());

// Fallbacks for browsers without pageswap/pagereveal.
window.addEventListener('pagehide', () => startNavigationBar());
window.addEventListener('pageshow', () => finishNavigationBar());

// If the user comes back to the tab, ensure we don't leave the bar "stuck".
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') finishNavigationBar();
});

